export default "__VITE_ASSET__BrOV6a9___"